<template>
    <div class="w-full">
        <dt class="transition-colors cursor-pointer bg-zinc-100 rounded-md py-4 px-5 lg:px-10" @click="toggleTranscript" role="button" :id="id">
            <div class="font-semibold leading-tight lg:text-lg">
                <div class="flex justify-between items-center w-full text-left">
                    {{ question }}
                    <span v-show="open" class="pr-2 text-xs">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                        </svg>
                    </span>
                    <span v-show="!open" class="pr-2 text-xs">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                        </svg>
                    </span>
                </div>
            </div>
        </dt>


        <div class="mt-2 pt-2 leading-relaxed lg:leading-relaxed font-light px-5 lg:px-6 lg:text-lg text-left" :class="[ open ? 'block' : 'hidden' ]">
            <dd>
                <slot></slot>
            </dd>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            question: String,
            id: String,
        },

        data() {
            return {
                open: false
            }
        },

        methods: {
            toggleTranscript() {
                this.open = ! this.open;
            },
        }
    }
</script>

<style scoped>
.expandable {
    height: 0px;
    overflow: hidden;
    opacity: 0;
    transition: all .15s ease-in-out;
}

.expandable.is-expanded {
    height: auto;
    opacity: 1;
}
</style>
